module.exports = __webpack_public_path__ + "static/media/about_niko.793a696e.png";